import React from 'react';
import ContactPanel from '../../components/site/ContactPanel';
import FaqList from '../../components/site/FaqList';
import FeatureGrid from '../../components/site/FeatureGrid';
import HeroSection from '../../components/site/HeroSection';
import HowItWorksFlow from '../../components/site/HowItWorksFlow';
import SectionTitle from '../../components/site/SectionTitle';
import {useSiteContent} from './siteContent';
import styles from './SitePages.module.css';

const ContactPage: React.FC = () => {
    const {contactPage, heroMetrics, primaryCta, secondaryCta} = useSiteContent();

    return (
        <div className={styles.page}>
            <section className={styles.section}>
                <HeroSection
                    description={contactPage.hero.description}
                    eyebrow={contactPage.hero.eyebrow}
                    metrics={heroMetrics}
                    panelDescription={contactPage.hero.panelDescription}
                    panelLabel={contactPage.hero.panelLabel}
                    panelTitle={contactPage.hero.panelTitle}
                    title={contactPage.hero.title}
                />
            </section>

            <section className={styles.section}>
                <SectionTitle
                    description={contactPage.hero.description}
                    eyebrow={contactPage.hero.eyebrow}
                    title={contactPage.hero.panelTitle}
                />
                <div className="site-section"/>
                <FeatureGrid items={contactPage.contactModes}/>
            </section>

            <section className={styles.section}>
                <SectionTitle
                    description={contactPage.hero.panelDescription}
                    eyebrow={contactPage.hero.panelLabel}
                    title={contactPage.hero.title}
                />
                <div className="site-section"/>
                <HowItWorksFlow steps={contactPage.applicationSteps}/>
            </section>

            <section className={styles.section} id="contact-form">
                <SectionTitle
                    description={contactPage.hero.assistText}
                    eyebrow={contactPage.hero.bottomCardLabel ?? contactPage.hero.panelLabel}
                    title={contactPage.hero.bottomCardTitle ?? contactPage.hero.panelTitle}
                />
                <div className="site-section"/>
                <ContactPanel/>
            </section>

            <section className={styles.section}>
                <div className={styles.faqWrap}>
                    <article className={`site-card ${styles.faqCard}`}>
                        <span className="site-eyebrow">{contactPage.faqIntro.eyebrow}</span>
                        <h3>{contactPage.faqIntro.title}</h3>
                        <p>{contactPage.faqIntro.description}</p>
                    </article>
                    <article className={`site-card ${styles.faqCard}`}>
                        <FaqList items={contactPage.faqItems}/>
                    </article>
                </div>
            </section>
        </div>
    );
};

export default ContactPage;
